import { IDefault } from "../default.type";

export class AccessLevelStatic {
  static noAccess: IDefault = { id: "aafc1a91-f39d-4d14-b294-6fd628dcb289", name: "Sem acesso" };
  static view: IDefault = { id: "704d4abc-f3f8-4700-ba3d-d8556859d82d", name: "Visualizar" };
  static editMine: IDefault = { id: "506d84ea-146f-4e2a-a380-5132937f01fd", name: "Editar somente os meus" };
  static edit: IDefault = { id: "25d72bd8-0256-4c21-9a8e-ed84204c3e1d", name: "Editar" };
}